import Bottleneck from 'bottleneck';

export const reqLimiter = new Bottleneck({
  maxConcurrent: 20,
  minTime: 20,
});
